<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>课程中心</span><span>/</span><span>自研课程</span></div>
    <div class="disFlex between curse-search">
      <div>
        <el-button type="primary" @click="toAdd()">新建课程</el-button>
      </div>
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-input v-model="formInline.keyword" placeholder="请输入名称查询" clearable suffix-icon="el-icon-search">
            </el-input>
          </el-form-item>

          <el-form-item label="">
            <el-select v-model="formInline.itype" placeholder="全部培训类别" clearable>
              <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text"
                style="width: 100%;">
                <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                  :value="item.uniqueCode">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="width: 130px;">
            <el-select v-model="formInline.state" placeholder="请选择状态" clearable>
              <el-option label="正常" value="1"></el-option>
              <el-option label="已过期" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading">
      <div class="disFlex" style="flex-wrap:wrap;" v-if="tableData.rows.length>0">
        <div class="curseInfoBlock" v-for="(item,k) in tableData.rows"
          :style="k>0&&k%4==3&&!collapse?'margin-right:0;':''">
          <div :class="'disFlex between curseevery-top'+(item.state=='3'?'ygq':'')">
            <el-image style="width: 256px; height: 152px;border-radius: 6px 6px 0 0;" :src="wjSrc+item.img"></el-image>

            <div class="delVurse">
              <span @click="delCurse(item.id)"><i class="el-icon-delete" style="padding-right: 3px;"></i>删除</span>
            </div>
          </div>
          <div class="disFlex between curseevery-center">
            <div class="curseevery-title ellipsis">
              <span>自研</span>{{item.cname}}
            </div>
          </div>
          <div class="disFlex curseevery-bot">
            <div class="flex2" @click="toEdit(item.id)">
              <img src="@/assets/images/icons/edit.png" />
              编辑
            </div>
            |
            <div class="flex2" @click="toDetail(item.id)">
              <img src="@/assets/images/icons/view.png" />
              查看
            </div>
            |
            <div class="flex2">
              <el-popover placement="right" trigger="hover">
                <div>
                  <!-- <div class="czitem-list" @click="showBm(item.id,item.cname,item.itype,item.cid,item.appUsers)">人员管理
                  </div> -->
                  <div class="czitem-list" @click="toAddLxt(item)">添加练习题</div>
                  <!-- <div class="czitem-list" @click="getSpsc(item)">更新视频时长</div> -->
                  <!-- <div class="czitem-list" @click="showGlsj(item.id,item.ontype,item.isset)">
                    {{item.isset==0?'设置试卷':'查看试卷'}}
                  </div> -->
                </div>
                <span slot="reference">
                  <img src="@/assets/images/icons/shezhi.png" style="margin-top: -2px;" />设置</span>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="height: 200px;background-color: #fff;text-align: center;">
        <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
        <div style="font-size: 18px;color: #999999;">暂无数据</div>
      </div>
    </div>
    <el-pagination :hide-on-single-page="true" style="margin-top: 10px;text-align: right;" background
      @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.page"
      :page-sizes="[10, 20, 50, 100]" :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.total">
    </el-pagination>


    <el-dialog title="人员管理" :visible.sync="dialogVisible" width="989px" :append-to-body="true" :destroy-on-close="true">
      <baoming-list flag="2" :selectUserIds="selectUserIds" @changeBb="changeBb" :wjSrc="wjSrc" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAave">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="设卷设置" :visible.sync="dialogSetVisible" width="989px" :append-to-body="true"
      :destroy-on-close="true">
      <shijuan-list :currentUser="currentUser" @changeSet="changeSet" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSetVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSetAave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import BaomingList from '../common/BaomingList';
  import ShijuanList from '../common/ShijuanList';
  export default {
    props: ['collapse', 'wjSrc', 'zyjnList', 'zyzclist', 'currentUser'],
    data() {
      return {
        formInline: {
          keyword: '',
          state: '',
          page: 1,
          rows: 10,
          flag: '3',
          cid: '',
          own: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        circleUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        options: [{
            text: '专业职称',
            uniqueCode: 'ZXKT_producttype_2',
            children: []
          },
          {
            text: '专业技能',
            uniqueCode: 'ZXKT_producttype_3',
            children: []
          }
        ],
        dialogVisible: false,
        selectUserIds: [],
        selectIdArr: [],
        selectRows: [],
        bmparams: {},
        loading: true,
        dialogSetVisible: false
      }
    },
    methods: {
      getSpsc: function(obj) {
        if (obj.filepath) {
          this.$axios.get('/file/attachment/getFileTimeByALY.htm?videoid=' + obj.filepath).then(res => {
            if (res.data.xstime) {
              this.$axios.post('/kt/ktCurriculum/update.htm', this.$qs.stringify({
                  id: obj.id,
                  xstime: res.data.xstime
                }))
                .then(res2 => {
                  var data2 = res2.data;
                  if (data2.stat == '1') {
                    this.$message({
                      message: '课程时长更新成功！',
                      type: 'success',
                      duration: 1000
                    });
                  } else {
                    this.$message.error(data2.message);
                  }
                })
            } else {
              this.$message.warning('视频正在解析中,请稍后5分钟再获取视频时长!');
            }
          });
        } else {
          this.$message.warning('请先上传视频!');
        }
      },
      getcurseList: function() {
        this.loading = true;
        this.$axios.get('/kt/productInfo/get2listPage.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
          }
          this.loading = false;
        })
      },
      toAdd: function() {
        this.$router.push('/Company/CurriculumInfo');
      },
      toEdit: function(id) {
        this.$router.push('/Company/CurriculumInfo?id=' + id);
      },
      toDetail: function(id) {
        this.$router.push('/Company/CurseInfo?id=' + id + '&flag=2');
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      showBm: function(id, name, itype, cid, isUser) {
        isUser = isUser ? isUser : [];
        this.bmparams = {
          productname: name,
          productid: id,
          itype: itype,
          cid: cid,
          isUser: isUser
        };
        var selectUserIds = [];
        isUser.map((item) => {
          selectUserIds.push(item.id);
        });
        this.selectUserIds = selectUserIds;
        this.dialogVisible = true;
      },
      changeBb: function(selectIdArr, selectRows) {
        this.selectIdArr = selectIdArr;
        this.selectRows = selectRows;
      },
      changeSet: function(row) {
        this.selectSetRow = row;
      },
      handleAave: function() {
        var isUser = [];
        this.selectRows.map((item, i) => {
          isUser.push({
            appyuserid: item.id,
            appyusername: item.realName,
          })
        });
        this.$set(this.bmparams, 'isUser', JSON.stringify(isUser))
        var $this = this;
        this.$axios.post('/kt/ktProductAppy/allocation.htm', this.$qs.stringify(this.bmparams)).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.$message({
              message: data.message,
              type: 'success',
              onClose: function() {
                $this.getcurseList(1)
              }
            });
          } else {
            this.$message.error(data.message);
          }
          this.dialogVisible = false;
        })
      },
      delCurse: function(id) {
        var $this = this;
        this.$confirm('您确定要删除该课程吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/kt/ktCurriculum/del.htm?id=' + id).then(res => {
            var data = res.data;
            if (data.stat == '1') {
              this.$message.success(data.message)
              this.getcurseList(1);
            } else {
              this.$message.error(data.message);
            }
          })
        }).catch(() => {});
      },
      showGlsj: function(id, ontype, isset) {
        if (isset == '1') {
          this.$router.push('/Company/Addexam?id=' + id);
        } else {
          this.$router.push('/Company/Addexam?currid=' + id + '&ontype=' + ontype);
        }

      },
      handleSetAave: function() {
        var setparams = {
          state: 12,
          productid: this.setProductId,
          id: this.selectSetRow.id
        }
        this.$axios.post('/kt/ktPapersSet/update.htm', this.$qs.stringify(setparams)).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.$message.success(data.message);
            this.dialogSetVisible = false;
            this.getcurseList(1);
          } else {
            this.$message.error(data.message);
          }
          this.dialogVisible = false;
        });
      },
      toAddLxt: function(row) {
        sessionStorage.setItem('product_itype_zy', row.itype);
        sessionStorage.setItem('product_itypeName_zy', row.itypeName);
        this.$router.push('/Company/Addtest?id=' + row.id);
      }
    },
    created: function() {
      this.$set(this.formInline, 'cid', this.currentUser.orgId)
      this.options[0].children = JSON.parse(localStorage.getItem('zyzcList'));
      this.options[1].children = JSON.parse(localStorage.getItem('zyjnList'));
    },
    components: {
      BaomingList,
      ShijuanList
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getcurseList(1);
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .curse-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .curse-search .el-form-item {
    margin-bottom: 0;
  }

  .curseInfoBlock {
    width: 256px;
    height: 256px;
    opacity: 1;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .curseevery-title {
    width: 236px;
    height: 40px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    margin: 8px auto;
  }

  .curseevery-title span {
    width: 34px;
    height: 16px;
    opacity: 1;
    background: linear-gradient(126deg, #ff7254 11%, #ff1515 90%);
    border-radius: 6px 6px 6px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);
    color: #fff;
    font-size: 12px;
    display: inline-block;
    line-height: 16px;
    text-align: center;
    margin-right: 2px;
  }

  .curseevery-bot {
    width: 256px;
    height: 43px;
    opacity: 1;
    background: #fbfbfc;
    border-top: 1px solid #efefef;
    align-items: center;
    color: #9a9a9a;
    font-size: 13px;
    cursor: pointer;
    text-align: center;
  }

  .curseevery-bot img {
    margin-right: 4px;
  }

  .curseevery-top {
    position: relative;
  }

  .curseevery-top.ygq::after {
    content: "";
    content: '';
    display: block;
    width: 46px;
    height: 46px;
    background: url(../../assets/images/ygq.png) no-repeat;
    background-size: 46px 46px;
    position: absolute;
    right: 0;
    top: -1px;
  }

  .delVurse {
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    align-items: center;
    justify-content: center;
    transition: all 0.3s linear;
  }

  .delVurse span {
    cursor: pointer;
    font-size: 14px;
    color: #ff1515;
  }

  .curseevery-top:hover .delVurse {
    display: flex;
  }

  .el-popover {
    padding: 0 !important;
    width: 110px !important;
    min-width: 110px !important;
  }

  .czitem-list {
    width: 110px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    text-align: center;
    border-bottom: 1px solid #efefef;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/MyCurriculum.vue